<template>
  <div class="mar-b-30 "
       id="row1-content">
    <div class="all-manuscript">
      <div class="all-manuscript-task flex">
        <div class="ipub-h1 main_color all-manuscript-task-text ">All Manuscript Tasks
          <span class="main-color all-manuscript-task-num">{{total ? '('+total+')' : ''}}</span>
        </div>

      </div>
    </div>
    <div class="manuscript-type">
      <ul class="manuscript-type-list">
        <li :class="['manuscript-type-item', user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS')?'ipub-c-p':'']"
            @click="goToPage(index)"
            v-for="(item,index) in manuscriptType"
            :key="index">
          <div class="ipub-p2 main-color text">{{articleStatus[index]}}</div>
          <div class="ipub-p1 num">{{item || '--'}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { statisticManuscript } from '@/api/statistic'
import { ARTICLE_STATUS } from '@/utils/dict'

export default {
  props: {
    journalId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      manuscriptType: {},
      total: 0,
      articleStatus: ARTICLE_STATUS
    }
  },
  watch: {
    journalId: {
      handler (newV) {
        this.getManuscript(newV)
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted () {
    // this.getManuscript(this.journalId)
  },
  methods: {
    async getManuscript (journalId) {
      this.total = 0
      // console.log(this.journalId, '期刊id')
      let data = {
        journalId
      }
      this.manuscriptType = await statisticManuscript.get(data)
      for (let i in this.manuscriptType) {
        this.total += Number(this.manuscriptType[i])
      }

      if (!this.manuscriptType.UNCOMMITTED) {
        delete this.manuscriptType.UNCOMMITTED
      }
    },
    goToPage (val) {
      if (this.user.codeList && this.user.codeList.includes('EDITOR_TASK')) {
        this.$router.push('/editorial-office/manuscripts?status=' + val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#row1-content {
  .all-manuscript {
    &-task {
      font-size: 24px;
      &-text {
        // letter-spacing: 1px;
      }
    }
  }
  .manuscript-type {
    width: 100%;

    &-list {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      align-items: center;
      justify-content: space-between;
    }
    &-item {
      width: 24.6%;
      @media screen and (max-width: 1440px) {
        width: 33%;
      }
      height: 64px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 6px 0;
      padding: 0 12px;
      box-sizing: border-box;
      &-content {
        width: 386px;
        height: 64px;
        background: #ffffff;
        border-radius: 4px;
      }

      .num {
        font-size: 20px;
        font-family: $h_family;
        text-align: center;
      }
      .text {
        text-align: center;
      }
    }
  }
}
</style>
